import { useGetAddressType } from "@common/hook/useGetAddressType";
import { EADDRESS_TYPES } from "@constants";
import { BillingAddressForm } from "./BillingAddressForm";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";

export const MyBillingAddress = () => {
    const { addressField, getUserAddress, getUserAddressState } = useGetAddressType(EADDRESS_TYPES.BILLING);

    return (
        <HandleErrorAndLoading
            error={getUserAddressState.error}
            isLoading={getUserAddressState.isLoading}
            retryFetch={getUserAddress}
        >
            {addressField && <BillingAddressForm billingAddress={addressField} getUserAddress={getUserAddress} />}
        </HandleErrorAndLoading>
    );
};
